/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import {template} from 'lodash';
import {pluralize} from '../../../utils/vue_filters.ts';

export const buildSyncResultMessage = syncResponse => {
  if (syncResponse.syncErrors.length === 0) {
    const modalInfo = buildSuccessResultMessage(syncResponse);
    return {modalType: modalInfo.modalType, message: modalInfo.modalMessage};
  }
  return {modalType: 'error', message: 'Synchronization failed.'};
};

function buildWarningMessageEntry(warning) {
  return template('<li><%- warning %></li>')({warning});
}

// eslint-disable-next-line complexity
function buildSuccessResultMessage(syncResponse) {
  let modalType = 'success';
  let modalMessage = 'Synchronization successful.<br/><br/>';

  // eslint-disable-next-line id-length
  const numAffectedExternalRequests =
    syncResponse.externalRequestsCreatedCount
    + syncResponse.externalRequestsUpdatedCount
    + syncResponse.externalRequestsDeletedCount;

  if (syncResponse.syncWarnings.length > 0) {
    modalType = 'warning';
    modalMessage = 'Synchronization partially completed, ' +
      `${syncResponse.syncWarnings.length}
      ${pluralize(syncResponse.syncWarnings.length, 'warning')} occurred:
        <br/><br/>
        <ul class='sync-requests-info'>
          ${syncResponse.syncWarnings.map(buildWarningMessageEntry)}
        </ul>`;
  } else if (numAffectedExternalRequests === 0) {
    modalMessage = 'Synchronization completed, no external requests were ' +
      'found.<br/><br/>';
  }

  if (numAffectedExternalRequests > 0) {
    let syncedExternalRequests = '';

    if (syncResponse.externalRequestsCreatedCount > 0) {
      syncedExternalRequests += '<li>'
        + `${syncResponse.externalRequestsCreatedCount} external`
        + ` ${pluralize(syncResponse.externalRequestsCreatedCount, 'request')}`
        + ' created.</li>';
    }
    if (syncResponse.externalRequestsUpdatedCount > 0) {
      syncedExternalRequests += '<li>'
        + `${syncResponse.externalRequestsUpdatedCount} external`
        + ` ${pluralize(syncResponse.externalRequestsUpdatedCount, 'request')}`
        + ' updated.</li>';
    }
    if (syncResponse.externalRequestsDeletedCount > 0) {
      syncedExternalRequests += '<li>'
        + `${syncResponse.externalRequestsDeletedCount} external`
        + ` ${pluralize(syncResponse.externalRequestsDeletedCount, 'request')}`
        + ' deleted.</li>';
    }

    if (syncedExternalRequests !== '') {
      modalMessage += `
        <ul class='sync-requests-info'>
          ${syncedExternalRequests}
        </ul>`;
    }
  }

  return {modalType: modalType, modalMessage: modalMessage};
}
